/**
 * @generated SignedSource<<1bd1b677dad39d7a9ba26d19e76cf196>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesEditorSettingsMenuCatering_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorCateringSettings_data">;
  readonly " $fragmentType": "RoomRatesEditorSettingsMenuCatering_data";
};
export type RoomRatesEditorSettingsMenuCatering_data$key = {
  readonly " $data"?: RoomRatesEditorSettingsMenuCatering_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorSettingsMenuCatering_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesEditorSettingsMenuCatering_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesEditorCateringSettings_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "d7321e90774d8a087c94dab0e8970afe";

export default node;
